import moment from 'moment'
let year = moment().year()
let month = moment().month()
let day = moment().date()
const currentDate = moment().format('YYYY,MM,DD');
const currentStartDate = moment().format('YYYYMMDD');
const dateNextWeek = moment().add(1, 'weeks').format('YYYY,MM,DD');
const currentEndDate = moment().add(1, 'weeks').format('YYYYMMDD');
const nextDay = moment().add(1,'days').format('YYYY-MM-DD')
const nextDay2 = moment().add(8,'days').format('YYYY-MM-DD')
const eventStartDate = moment().add(1,'days').format('YYYYMMDD')
const eventEndDate = moment().add(8,'days').format('YYYYMMDD')
const trainDes2 = {
    eventPlace: '',
    amount: '100',
    applyDate: [new Date(currentDate), new Date(dateNextWeek)],
    applyTime: [new Date(year, month, day, 8, 30), new Date(year, month, day, 23, 30)],
    applyStartDate: currentStartDate,
    applyEndDate: currentEndDate,
    applyStartTime: '083000',
    applyEndTime: '233000',
    eventStartDate: eventStartDate,
    eventEndDate: eventEndDate,
    eventDate:  nextDay,
    eventDate2:  nextDay2,
    eventTime: [new Date(2024, 7, 10, 8, 30), new Date(2024, 7, 10, 23, 30)],
    eventStartTime: '083000',
    eventEndTime: '233000',
    area: '',
    provinces: '',
    city: '',
    signTime: '',
}
export default trainDes2


// WEBPACK FOOTER //
// ./src/config/trainDes2.js